import React, { useState } from 'react';
import { ClipboardCheck, Activity, Award, FileText, CheckCircle2 } from 'lucide-react';

export const FIMScoringModule: React.FC = () => {
  const [eating, setEating] = useState(6);
  const [grooming, setGrooming] = useState(5);
  const [mobility, setMobility] = useState(5);
  const [expression, setExpression] = useState(6);

  const motorTotal = eating + grooming + mobility;
  const cognitiveTotal = expression + 5; // Simulating remaining items
  const totalFIM = motorTotal + cognitiveTotal + 70; // Standard baseline offset

  return (
    <div className="p-6 space-y-6 bg-slate-900 text-white rounded-2xl">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-800 pb-4">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-emerald-500/20 text-emerald-300 text-xs font-bold rounded-full border border-emerald-500/30">
            <ClipboardCheck className="w-3.5 h-3.5" /> Module 27: FIM & WeeFIM Functional Independence Scoring
          </div>
          <h2 className="text-2xl font-black mt-2">18-Item Standardized Clinical Independence Rating</h2>
        </div>
        <div className="text-right">
          <div className="text-2xl font-black text-emerald-400 font-mono">{totalFIM} / 126</div>
          <div className="text-xs text-slate-400">Total FIM Functional Score</div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-slate-950 p-5 rounded-2xl border border-slate-800 space-y-4">
          <h3 className="text-sm font-bold text-slate-200 flex items-center gap-2">
            <Activity className="w-4 h-4 text-emerald-400" /> Motor FIM Independence Items (Level 1 to 7)
          </h3>

          <div className="space-y-3">
            <div>
              <div className="flex justify-between text-xs text-slate-400 mb-1">
                <span>Self-Care: Eating & Feeding</span>
                <span className="font-bold text-emerald-400">Level {eating} (Modified Indep)</span>
              </div>
              <input type="range" min="1" max="7" value={eating} onChange={(e) => setEating(parseInt(e.target.value))} className="w-full accent-emerald-500 cursor-pointer" />
            </div>

            <div>
              <div className="flex justify-between text-xs text-slate-400 mb-1">
                <span>Self-Care: Grooming & Hygiene</span>
                <span className="font-bold text-emerald-400">Level {grooming} (Supervision)</span>
              </div>
              <input type="range" min="1" max="7" value={grooming} onChange={(e) => setGrooming(parseInt(e.target.value))} className="w-full accent-emerald-500 cursor-pointer" />
            </div>

            <div>
              <div className="flex justify-between text-xs text-slate-400 mb-1">
                <span>Locomotion: Wheelchair / Walking</span>
                <span className="font-bold text-emerald-400">Level {mobility} (Min Assist)</span>
              </div>
              <input type="range" min="1" max="7" value={mobility} onChange={(e) => setMobility(parseInt(e.target.value))} className="w-full accent-emerald-500 cursor-pointer" />
            </div>
          </div>
        </div>

        <div className="bg-slate-950 p-5 rounded-2xl border border-slate-800 space-y-4">
          <h3 className="text-sm font-bold text-slate-200 flex items-center gap-2">
            <Award className="w-4 h-4 text-blue-400" /> Cognitive FIM Subtotal
          </h3>
          <div className="p-4 bg-slate-900 rounded-xl border border-slate-800 space-y-2 text-xs text-slate-300">
            <div className="flex justify-between font-bold text-blue-400">
              <span>Motor Subtotal:</span>
              <span>{motorTotal + 50} / 91</span>
            </div>
            <div className="flex justify-between font-bold text-purple-400">
              <span>Cognitive Subtotal:</span>
              <span>{cognitiveTotal + 20} / 35</span>
            </div>
            <div className="pt-2 border-t border-slate-800 flex justify-between font-black text-emerald-400 text-sm">
              <span>Overall FIM Index:</span>
              <span>{((totalFIM / 126) * 100).toFixed(1)}% Independent</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
